<template>
  <v-dialog :value="visible" @input="$emit('close')" max-width="500">
    <v-card>
      <v-card-title class="text-h6 grey--text text--darken-3"> CPF já cadastrado </v-card-title>

      <v-card-text>
        Este CPF pertence a {{ artigo }} {{ tipoTexto }} cadastrado{{ concordancia }} no sistema.<br />
        <strong>Nome:</strong> {{ nome }}<br /><br />
        Por favor, utilize um CPF diferente.
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="primary" @click="$emit('close')"> OK </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CpfDuplicadoModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      required: true,
      validator(value) {
        return ["aluno", "professor", "usuario"].includes(value);
      },
    },
    nome: {
      type: String,
      default: "",
    },
    contexto: {
      type: String,
      required: true,
      validator(value) {
        return ["aluno", "professor", "usuario"].includes(value);
      },
    },
  },
  computed: {
    tipoTexto() {
      const textos = {
        aluno: "aluno",
        professor: "professor",
        usuario: "usuário",
      };
      return textos[this.tipo] || "";
    },
    artigo() {
      return this.tipo === "aluno" ? "um" : "um";
    },
    concordancia() {
      return this.tipo === "aluno" ? "" : "";
    },
    contextoTexto() {
      const textos = {
        aluno: "aluno",
        professor: "professor",
        usuario: "usuário",
      };
      return textos[this.contexto] || "";
    },
    artigoContexto() {
      return this.contexto === "aluno" ? "um" : "um";
    },
    mostrarMensagemNaoPode() {
      return this.tipo !== this.contexto;
    },
  },
};
</script>
